import { debounce } from 'lodash-es';
import replaceRoute from './replaceRoute';

export default debounce(
  (route, query) => replaceRoute(route, query),
  500,
);
